const SUPERUSER = "SU";
const EMPLOYEE = "EM";

export default {
  SUPERUSER: SUPERUSER,
  EMPLOYEE: EMPLOYEE,
};
